import { Button } from '@tmov/design-system';
import styled from 'styled-components';

export const DrawerHeaderButtonText = styled(Button).attrs({
  variant: 'text',
  size: 'sm',
})`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
`;
